import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'tiktok-third-party-glyph-icon'

export function TikTokSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M23.01 12.012a4.034 4.034 0 0 1-4.04-4h-2.608v7.128l-.004 3.904A2.36 2.36 0 0 1 13.86 21.4a2.351 2.351 0 0 1-1.08-.331 2.36 2.36 0 0 1-1.154-1.99 2.363 2.363 0 0 1 3.11-2.276V14.155a5.14 5.14 0 0 0-.752-.056c-1.443 0-2.793.6-3.758 1.681a4.893 4.893 0 0 0-1.234 2.952 4.887 4.887 0 0 0 1.455 3.807 5.003 5.003 0 0 0 3.537 1.448 4.985 4.985 0 0 0 3.537-1.448 4.883 4.883 0 0 0 1.465-3.475l-.013-5.83a6.594 6.594 0 0 0 4.044 1.374v-2.596h-.007Z" />
    </symbol>
  )
}

const TikTokStandaloneContent = standalone(TikTokSymbol, ID)

export const Tiktok = styled(function TikTokStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-tiktok">
      <TikTokStandaloneContent />
    </Icon>
  )
})``

export const TikTokLightweight = styled(function TikTokComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-tiktok">
      {lightweight(ID)}
    </Icon>
  )
})``
